<script lang="ts">
    import { page } from "$app/stores";
    import { afterUpdate } from "svelte";
    import NewsSectionCMU from "../../Beranda/catchmeup/NewsSectionCMU.svelte";

    export let currentNamePage: any;
    export let primaryColor: any;
    export let news: any;
    export let categories: any;
    export let client: any;

    $: category = $page.params.slug;
    $: categoriesv2 = categories?.find((item: any) => item.slug === category);
</script>

<div id="core">
    <div class="core__inner">
        <!-- MAIN : begin -->
        <main id="main">
            <div class="main__inner">
                <!-- MAIN CONTENT : begin -->
                <div class="main__content">
                    <div class="main__content-wrapper">
                        <div class="main__content-inner">
                            <div class="lsvr-container">
                                <!-- POST ARCHIVE : begin -->
                                <div
                                    class="post-archive post-archive--grid blog-post-page blog-post-archive blog-post-archive--grid post-archive--layout-style-dark"
                                >
                                    <header class="main-header">
                                        <div class="main-header__inner">
                                            <h1 class="font-medium">
                                                Berita Terkini
                                            </h1>
                                        </div>
                                    </header>
                                    <NewsSectionCMU
                                        {categoriesv2}
                                        {primaryColor}
                                        data={news}
                                        {categories}
                                        {client}
                                        {currentNamePage}
                                    />
                                </div>
                                <!-- POST ARCHIVE : end -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- MAIN CONTENT : begin -->
            </div>
        </main>

        <!-- MAIN : end -->
    </div>
</div>
